// 指導員/受講結果の変更フォーム
export default () => {
  const updateFormStatus = (form, result) => {
    const enableOn = JSON.parse(form.dataset.enableOn);
    form.disabled = !enableOn.includes(result);
  };

  // 受講判定によって受講開始・終了フォームの状態を更新
  const updateAttendanceResultFormStatus = () => {
    const startedAt = document.getElementById('attendance_started_at');
    const endedAt = document.getElementById('attendance_ended_at');
    const attendanceResult = document.getElementById('attendance_result');
    const result = attendanceResult.value;

    updateFormStatus(startedAt, result);
    updateFormStatus(endedAt, result);
  };

  const attendanceResult = document.getElementById('attendance_result');
  const deletionProtection = document.getElementById('attendance_deletion_protection');

  if (attendanceResult) {
    attendanceResult.addEventListener('change', updateAttendanceResultFormStatus, false);
    window.addEventListener('load', updateAttendanceResultFormStatus);

    const form = document.getElementById('attendance-form');
    // 却下以外->却下で登録ボタンを押されたときのみ
    if (attendanceResult.value !== 'rejected') {
      form.addEventListener('submit', (e) => {
        if (attendanceResult.value !== 'rejected') return;

        let message = '受講判定「却下」とその判定理由が教習生に通知されますが、よろしいですか？';
        // 画像ログ保護が無効の場合
        if (deletionProtection.value === 'disable') {
          message =
            '受講判定「却下」とその判定理由が教習生に通知されます。\nまた、ログ画像の保護フラグが有効になっていません。\n進めてよろしいですか？';
        }

        if (!window.confirm(message)) {
          e.stopPropagation();
          e.preventDefault();
        }
      });
    }
  }
};
